<template>
    <button class="btn btn-warning" @click="QRData">
        <slot><i class="fas fa-credit-card"></i></slot>
    </button>
</template>

<script>
    import { EventBus } from '../eventBus.js';

    export default{
        //extends: ExampleComponent,
        props: ['id', 'name'],
        methods: {
            QRData() {
                // alert(`I am ${this.name}!`)
                EventBus.$emit('InvoiceValue', this.id,this.name) 
            }
        },
    }
</script>